<template>
  <div>
    <div class="row" v-if="loading">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="text-center text-primary my-2" >
              <b-spinner class="align-middle mr-2"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </div>
        </div>
      </div>
    </div>

    <template v-if="!loading">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">

              <h4 class="card-title">
                {{ detail.first_name }}, {{ detail.last_name }}
              </h4>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <form
                method="post"
                class="needs-validation"
                @submit.prevent="onSubmit"
                novalidate
                enctype="multipart/form-data"
                :class="
                  submitted
                    ? 'needs-validation was-validated'
                    : 'needs-validation'
                "
              >
                <input
                  type="hidden"
                  name="csrfmiddlewaretoken"
                  value="eJA23nk5IpEW2yiuE3UPuEcIUE0fxQtWjPDM5q5TLmUqGWN2lgApd92YPspEQ5DA"
                />

                <div class="row">

                  <div class="col-lg-4">
                    <label for="organization_id">Organization*</label>
                    <select
                      name="organization"
                      class="form-control"
                      required=""
                      disabled=""
                    >
                      <option value="1" selected="selected">
                         <option selected="selected">{{this.currentOrg.organization.name}}</option>
                      </option>
                    </select>
                    <input
                      type="hidden"
                      name="organization"
                      id="organization_id"
                      value="1"
                    />
                  </div>

                  <div class="col-lg-4">
                    <label for="job_title_id">Job Title</label>
                    <input
                      type="text"
                      name="job_title"
                      id="job_title_id"
                      class="form-control"
                      maxlength="255"
                      v-model.trim="$v.job_title.$model"
                    />
                  </div>

                  <div class="col-lg-4">
                    <label for="department_id">Department</label>
                    <input
                      type="text"
                      name="department"
                      id="department_id"
                      class="form-control"
                      maxlength="255"
                      v-model.trim="department"
                    />
                  </div>
                </div>

                <p></p>

                 <div class="row">
                  <div class="col-lg-4">
                    <label for="email_id">Work Email</label>
                    <input
                      type="email"
                      name="email"
                      id="email_id"
                      class="form-control"
                      v-model.trim="$v.email.$model"
                    />
                  </div>
                  <div class="col-lg-4">
                    <label for="mobile_phone_id">Work Mobile Phone</label>
                    <input
                      type="text"
                      name="mobile_phone"
                      id="phone_number_id"
                      v-model.trim="$v.mobile_phone.$model"
                      class="form-control"
                      placeholder="999-999-9999"
                      v-mask="'###-###-####'"
                    />
                    <div
                      v-if="submitted && !$v.mobile_phone.customPhoneValidate"
                      class="invalid-tooltip"
                    >
                      You should provide a phone number (###-###-####)
                    </div>
                  </div>

                  <div class="col-lg-4">
                    <label for="office_phone_id">Work Office Phone</label>
                    <input
                      type="text"
                      name="office_phone"
                      id="office_phone_id"
                      v-model.trim="$v.office_phone.$model"
                      class="form-control"
                      placeholder="999-999-9999"
                      v-mask="'###-###-####'"
                    />
                    <div
                      v-if="submitted && !$v.office_phone.customPhoneValidate"
                      class="invalid-tooltip"
                    >
                      You should provide a phone number (###-###-####)
                    </div>
                  </div>
                </div>

                <p></p>

                <div class="row">
                  <div class="col-lg-4">
                    <label for="ice_handle">ICE Handle</label>
                    <input
                      type="text"
                      name="ice_handle"
                      id="ice_handle"
                      v-model.trim="ice_handle"
                      class="form-control"
                    />
                  </div>

                  <div class="col-lg-4">
                    <label for="teams_handle">Teams Handle</label>
                    <input
                      type="text"
                      name="teams_handle"
                      id="teams_handle"
                      v-model.trim="teams_handle"
                      class="form-control"
                    />
                  </div>

                  <div class="col-lg-4">
                    <label for="Salutation">Salutation</label>
                    <input
                      type="text"
                      name="salutation"
                      id="Salutation"
                      v-model.trim="salutation"
                      class="form-control"
                    />
                  </div>
                </div>
                <p></p>

                <div class="row">
                  <div class="col-lg-4">
                    <label for="employment_status_id">Employment Status*</label>
                    <select
                      name="employment_status"
                      id="employment_status_id"
                      class="form-select"
                      required
                      v-model.trim="employment_status"
                    >
                      <option value="active">Active</option>

                      <option value="expired">Expired</option>
                    </select>
                  </div>
                </div>

                <p></p>

                <h5 class="font-size-14 mt-5">CONTACT PREFERENCES</h5>
                <p></p>

                <div class="row">
                  <div class="col-lg-6">
                    <label for="job_title_id"
                      >Preferred Time of Day for Calls</label
                    >
                    <input
                      type="text"
                      name="job_title"
                      id="job_title_id"
                      class="form-control"
                      v-model.trim="prefered_time_of_day_calls"
                    />
                  </div>
                  <div class="col-lg-6">
                    <label for="prefered_time_of_day_emails"
                      >Preferred Time of Day for Emails</label
                    >
                    <input
                      type="text"
                      name="prefered_time_of_day_emails"
                      id="prefered_time_of_day_emails"
                      class="form-control"
                      v-model.trim="prefered_time_of_day_emails"
                    />
                  </div>
                </div>
                <p></p>

                <div class="row">
                  <div class="col-lg-6">
                    <label for="prefered_day_of_week_calls"
                      >Preferred Day of Week for Calls</label
                    >
                    <input
                      type="text"
                      name="prefered_day_of_week_calls"
                      id="prefered_day_of_week_calls"
                      class="form-control"
                      v-model.trim="prefered_day_of_week_calls"
                    />
                  </div>
                  <div class="col-lg-6">
                    <label for="prefered_day_of_week_emails"
                      >Preferred Day of Week for Emails</label
                    >
                    <input
                      type="text"
                      name="prefered_day_of_week_emails"
                      id="prefered_day_of_week_emails"
                      class="form-control"
                      v-model.trim="prefered_day_of_week_emails"
                    />
                  </div>
                </div>
                <p></p>

                <div class="row">
                  <div class="col-lg-6">
                    <label for="prefered_checkin_frequency"
                      >Preferred Check-in Frequency</label
                    >
                    <input
                      type="text"
                      name="prefered_checkin_frequency"
                      id="prefered_checkin_frequency"
                      class="form-control"
                      v-model.trim="prefered_checkin_frequency"
                    />
                  </div>
                </div>
                <p></p>

                <p></p>

                <div>
                  <button
                    class="btn btn-success"
                    :disabled="loadingAction"
                    type="submit"
                  >
                    Save
                  </button>
                  <button type="button" class="btn btn-light waves-effect" @click="$router.go(-1)">
                    <!-- <router-link
                      :to="
                        '/mpg/contacts/' + $route.params.id + '/organizations'
                      "
                      ></router-link
                    > -->
                    Cancel
                  </button>
                </div>

              </form>

            </div>

          </div>

        </div>

      </div>
    </template>
  </div>
</template>

<script>
import { contactsService } from '../services/contacts.service'
import { email } from 'vuelidate/lib/validators'
import moment from 'moment'
import { router } from '../router'
import { customPhoneValidate } from '../helpers'

export default {
  name: 'EditOrgToContact',
  components: {},
  data () {
    return {
      organizationList: [],
      organization: '',
      first_name: '',
      last_name: '',
      middle_name: '',
      person_title: '',
      department: '',
      address: '',
      mobile_phone: '',
      mobile_phone_raw: '',
      office_phone: '',
      office_phone_raw: '',
      personal_mobile: '',
      personal_mobile_raw: '',
      email: '',
      date_of_birth: '',
      ice_handle: '',
      teams_handle: '',
      linkedin_url: '',
      salutation: '',
      prefered_time_of_day_calls: '',
      prefered_time_of_day_emails: '',
      prefered_day_of_week_calls: '',
      prefered_day_of_week_emails: '',
      prefered_checkin_frequency: '',
      ext: '',
      job_title: '',
      gender: 'male',
      personal_email: '',
      submitted: false,
      loading: true,
      loadingAction: false,
      error: '',
      employment_status: '',
      detail: {}
    }
  },
  validations: {
    organization: {},
    email: { email },
    job_title: {},
    mobile_phone: { customPhoneValidate },
    office_phone: { customPhoneValidate }
  },
  computed: {},
  created () {
    if (!this.$route.params.id || this.$route.params.id === '') {
      router.push('/mpg/contacts/')
    }

    contactsService.getDataById(this.$route.params.id).then((rs) => {
      this.detail = rs
      this.loading = false
      this.currentOrg = this.detail.organizations_contacts.find((org) => {
        return (
          org.organization.organization_id.toString() ===
          this.$route.params.orgId
        )
      })
      this.job_title = this.currentOrg.job_title
      this.employment_status = this.currentOrg.employment_status
      this.email = this.currentOrg.work_email
      this.mobile_phone = this.currentOrg.work_mobile
      this.office_phone = this.currentOrg.work_office_phone

      this.prefered_time_of_day_calls = this.currentOrg.prefered_time_day_calls
      this.prefered_time_of_day_emails =
        this.currentOrg.prefered_time_day_emails
      this.prefered_day_of_week_calls =
        this.currentOrg.prefered_time_week_day_calls
      this.prefered_day_of_week_emails =
        this.currentOrg.prefered_time_week_day_emails
      this.prefered_checkin_frequency =
        this.currentOrg.prefered_checkin_frequency
      this.salutation = this.currentOrg.salutation
      this.ice_handle = this.currentOrg.ice_handle
      this.teams_handle = this.currentOrg.teams_handle
      this.job_title = this.currentOrg.job_title
      this.department = this.currentOrg.department
    })
  },
  methods: {
    moment,
    onSubmit () {
      this.submitted = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      this.loadingAction = true
      const payload = {
        contact: this.$route.params.id,
        employment_status: this.employment_status,
        work_mobile: this.mobile_phone,
        job_title: this.job_title,
        work_email: this.email,
        work_office_phone: this.office_phone,
        department: this.department,
        ice_handle: this.ice_handle,
        teams_handle: this.teams_handle,
        salutation: this.salutation,
        prefered_time_day_calls: this.prefered_time_of_day_calls,
        prefered_time_day_emails: this.prefered_time_of_day_emails,
        prefered_time_week_day_calls: this.prefered_day_of_week_calls,
        prefered_time_week_day_emails: this.prefered_day_of_week_emails,
        prefered_checkin_frequency: this.prefered_checkin_frequency
      }
      contactsService
        .updateOrgToContact(payload, this.currentOrg.organization_contact_id)
        .then(
          (rs) => {
            this.$nextTick(() => {
              // router.push(
              //   `/mpg/contacts/${this.$route.params.id}/organizations/`
              // )
              this.$router.go(-1)
            })
          },
          (error) => {
            this.error = error
            this.loadingAction = false
          }
        )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/EditOrgToContact.vue